import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { useState } from "react";
import { useLocalizedStrings } from "../../localization/LocalizedStringsProvider";
import { fillHeight } from "../../theme";
import Playlists from "./Playlists";
import PlaylistSchedules from "./PlaylistSchedules";
import PlaylistConfiguration from "./PlaylistConfiguration";

// The Ad Banner nav item lands here: the playlists themselves, the schedules that decide when any of them
// run, and the playback settings.
//
// Advertisers left these tabs when the section became a Media Network - they are shared with Cross-Sell, so
// they belong beside the features rather than inside one, same as tags and the library.
//
// Configuration is a tab rather than a sibling nav item because the only thing it configures is banner
// playback — it has no meaning to the section's other features.
const PlaylistsHome = () => {
    const strings = useLocalizedStrings();
    const [tab, setTab] = useState(0);

    return (
        <Box sx={{ ...fillHeight, overflow: "hidden", display: "flex", flexDirection: "column" }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={tab} onChange={(_e, v) => setTab(v)}>
                    <Tab label={strings.playlists} />
                    <Tab label={strings.schedule} />
                    <Tab label={strings.configuration} />
                </Tabs>
            </Box>

            <Box sx={{ flex: 1, minHeight: 0, p: 2 }}>
                {tab === 0 ? <Playlists />
                    : tab === 1 ? <PlaylistSchedules />
                    : <PlaylistConfiguration />}
            </Box>
        </Box>
    );
};

export default PlaylistsHome;
